import { render, staticRenderFns } from "./ClientSadadSalesAverageReportPrint.vue?vue&type=template&id=3872977d&"
import script from "./ClientSadadSalesAverageReportPrint.vue?vue&type=script&lang=js&"
export * from "./ClientSadadSalesAverageReportPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports